import { render, staticRenderFns } from "./VerificationPhone.vue?vue&type=template&id=ce88a2b6&lang=html"
import script from "./VerificationPhone.vue?vue&type=script&lang=js"
export * from "./VerificationPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports